import tripEvents from './../../config/events.constant';

export default function TripCheckoutLuggageController(
    $rootScope,
    $scope,
    tripData,
    tripDetails,
) {
    'ngInject';

    const vm = this;
    $scope.isAvailable = false;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        $scope.discountedLuggage = [];
        $scope.luggageConfig = tripData.LuggageOptions;
        $scope.isAvailable = tripData.isAvailable && tripData.LuggageOptions.length > 0;
        $scope.isApproved = tripData.IsApproved;
        $scope.flightsData = tripDetails.Flights;
        $scope.isActive = false;

        $rootScope.$on(tripEvents.UPDATE_DISCOUNT_LUGGAGE, (event, discountedLuggage) => $scope.discountedLuggage = discountedLuggage);
    }

    $scope.changeVisibility = function() {
        $scope.isActive = !$scope.isActive;
    };

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/tripCheckoutLuggageController.js